export const EVENT_BUS_LAYOUT_ON_WIDTH_MAIN_CHANGE = 'layout:widthMain:change'
export const EVENT_BUS_LAYOUT_ON_HEIGHT_MAIN_CHANGE = 'layout:heightMain:change'
export const EVENT_BUS_LAYOUT_ON_WIDTH_CHANGE = 'layout:width.change'
export const EVENT_BUS_LAYOUT_ON_HEIGHT_CHANGE = 'layout:height.change'

export const BUS_LAYOUT_MENU_MIN_POPOVER_CHAGED = 'layout:menu-min-popover-changed'
